import React from "react"
import { render, cleanup } from "@testing-library/react"
import { PrimaryNavLinks } from "../SidebarPrimaryList"

export const sidebarNavListItemsSample = [
  {
    iconName: "dashboard",
    href: "/happy/",
    linkName: "Happy Link",
    isActive: true
  },
  {
    iconName: "library_books",
    href: "/plans",
    linkName: "Plans"
  }
]

afterEach(cleanup)

describe("<SidebarPrimaryList />", () => {
  it("properly displays primary links", () => {
    const { getByText } = render(
      <PrimaryNavLinks primaryLinkData={sidebarNavListItemsSample} />
    )
    expect(getByText("Happy Link")).toBeInTheDocument()
    expect(getByText("Plans")).toBeInTheDocument()
  })
  it("properly displays current active link", () => {
    const { container } = render(
      <PrimaryNavLinks primaryLinkData={sidebarNavListItemsSample} />
    )

    expect(container.querySelector("[aria-current=page]")).toHaveTextContent(
      "Happy Link"
    )
  })
})
